import { NAVIGATION_COPY } from '@/locales/en'
import { H3 } from '@/common/ui'
import type { DetailItem } from '../types'
import { DetailListSection } from '@/common/ui/DetailListSection'
import { DetailItemContent } from './SettingsListItems'

interface AccountHolderGroup {
    key: string
    items: DetailItem[]
}

type Props = {
    accountHolders: DetailItem[][]
}

export default function AccountHoldersSection({ accountHolders }: Props) {
    const copy = NAVIGATION_COPY.account

    const holders: AccountHolderGroup[] = accountHolders.map((items, index) => {
        const email = items.find((item) => item.key === 'email')?.value
        const name = items.find((item) => item.key === 'name')?.value
        const holderKey = email && email !== '-' ? email : name && name !== '-' ? name : `holder-${index}`

        return { key: holderKey, items }
    })

    return (
        <DetailListSection
            title={copy.personalDetailsTitle}
            items={holders}
            renderItem={(holder) => {
                const name = holder.items.find((item) => item.key === 'name')?.value
                return (
                    <div className="self-stretch p-6 rounded-2xl outline outline-1 outline-offset-[-1px] outline-border-outline inline-flex flex-col justify-start items-start gap-6">
                        <H3 className="justify-start text-black text-3xl font-normal font-['Serious_Sans'] leading-8">
                            {name}
                        </H3>
                        <div className="self-stretch flex flex-col justify-start items-start gap-3 md:gap-4">
                            {holder.items.map((item, index) => (
                                <div
                                    key={item.key}
                                    className="self-stretch flex flex-col justify-start items-start gap-3 md:gap-4"
                                >
                                    <DetailItemContent item={item} />
                                    {index < holder.items.length - 1 && (
                                        <div className="self-stretch h-0 border-t border-border-divider" />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )
            }}
            showDivider={false}
        />
    )
}
